'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.closeToast = closeToast;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_DONE = 'redux-frontend/loader/LOAD_DONE';
var REDUX_LOAD = 'reduxAsyncConnect/BEGIN_GLOBAL_LOAD';
var REDUX_LOADED = 'reduxAsyncConnect/END_GLOBAL_LOAD';
var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
// const SET_LOAD = 'redux-frontend/availability/SAVE_AVAIL';

var initialState = {
  loading: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_DONE:
      return (0, _extends3.default)({}, state, {
        loading: false
      });
    case LOCATION_CHANGE:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case REDUX_LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case REDUX_LOADED:
      return (0, _extends3.default)({}, state, {
        loading: false
      });
    default:
      return state;
  }
}

function closeToast() {
  return {
    type: LOAD_DONE
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/loader.js
// module id = 1704
// module chunks = 47